import { render, staticRenderFns } from "./Listing.vue?vue&type=template&id=4528f80c&scoped=true&"
import script from "./Listing.vue?vue&type=script&lang=js&"
export * from "./Listing.vue?vue&type=script&lang=js&"
import style0 from "./Listing.vue?vue&type=style&index=0&id=4528f80c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4528f80c",
  null
  
)

export default component.exports